import { SysRole, Loader } from "../../../components";
import { HugeiconsIcon } from '@hugeicons/react';
import { ArrowRight01Icon } from '@hugeicons/core-free-icons';

function UpdateRole({ staff, roleList, handleRoleSelect, updateRoles, process }) {
    
    return (
        <div className="space-y-5">
            <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-2.5">
                {roleList?.map((item, index) => (
                    <SysRole
                        key={index}
                        staff={staff}
                        role={item}
                        handleRoleSelect={handleRoleSelect}
                    />
                ))}
            </div>

            <div className="flex items-center gap-3 pt-1">
                <button
                    type="button"
                    onClick={updateRoles}
                    disabled={process}
                    className="inline-flex items-center gap-2 px-4 py-2.5 text-sm font-medium text-white bg-[#1e3a6e] rounded-lg hover:bg-[#264d91] disabled:opacity-50 transition-colors"
                >
                    {process ? <Loader color="text-white" size="w-4 h-4" /> : <HugeiconsIcon icon={ArrowRight01Icon} size={15} />}
                    Update Roles
                </button>
            </div>
        </div>
    );
}

export default UpdateRole;
